export default __webpack_public_path__ + "static/media/Que tipo.584be69b.png";